import React from 'react'
import { connect } from 'react-redux'
// import Loading from '../Shared/Loading'
import LoadingBar from '../Shared/LoadingBar'
import { history } from '../../_helpers'
import LoadingCircle from '../Shared/LoadingCircle'
import { memberService } from '../../_services/member.service'
import { toastr } from 'react-redux-toastr'
import moment from 'moment-jalaali'
import paymentStatuses from '../../_constants/paymentStatuses'
import NumberFormat from 'react-number-format'

function formatDateTime(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e, 'YYYY-MM-DD HH:mm:ss')
    if (momentValue.isValid()) {
      return momentValue.format('jYYYY/jMM/jDD  ساعت HH:mm:ss')
    }
  }
}

class MemberProfile extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: true,
      data: []
    }
  }

  componentDidMount = () => {
    LoadingBar(true)

    this.getData()
  }

  getData() {
    if (this.props.user && this.props.user.id) {
      this.setState({ memberId: this.props.user.id, loading: true }, () => {
        memberService
          .getById(this.props.user.id)
          .then(res => {
            // console.log(res.data)
            var data = res.data
            this.setState({ data: data, loading: false }, () => {
              LoadingBar(false)
            })
          })
          .catch(error => {
            this.handleError(error)
            // history.push('/member/exam')
          })
      })
    } else {
      toastr.warning('صفحه مورد نظر وجود ندارد')
      history.push('/member/')
    }
  }

  handleError(error) {
    this.setState({ loading: false })
    LoadingBar(false)
    // console.log(error);
  }

  render() {
    const { data, loading } = this.state

    return data ? (
      <div className="row">
        <div className="col-md-10 col-md-offset-1">
          <fieldset className="fieldset m-0">
            <legend>اطلاعات شما</legend>
            {data && (
              <table className="table table-profile m-0">
                <tbody>
                  {data.imagePath && (
                    <tr>
                      <td className="text-left w-50pr">تصویر</td>
                      <td className="text-right w-50pr">
                        <img src={data.imagePath} alt="" />
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td className="text-left w-50pr">نام و نام خانوادگی</td>
                    <td className="text-right w-50pr">
                      {data.gender === 0 ? 'آقای ' : 'سرکار خانم '}{' '}
                      {data.firstName + ' ' + data.lastName}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-left">کد ملی</td>
                    <td className="text-right">{data.nationalCode}</td>
                  </tr>
                  <tr>
                    <td className="text-left">شماره شناسنامه</td>
                    <td className="text-right">{data.idNumber}</td>
                  </tr>
                  {data.birthDate && data.birthDate !== '0001-01-01T00:00:00' && (
                    <tr>
                      <td className="text-left">تاریخ تولد</td>
                      <td className="text-right">
                        {formatDateTime(data.birthDate)}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td className="text-left">نام پدر</td>
                    <td className="text-right">{data.fatherName}</td>
                  </tr>
                  <tr>
                    <td className="text-left">شماره موبایل</td>
                    <td className="text-right">{data.mobile}</td>
                  </tr>
                  <tr>
                    <td className="text-left">اتحادیه</td>
                    <td className="text-right">
                      {data.union && data.union.name}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-left">کد رهگیری شناسه صنفی</td>
                    <td className="text-right">{data.senfNumber}</td>
                  </tr>
                  <tr>
                    <td className="text-left">کد ISIC</td>
                    <td className="text-right">{data.isicCode}</td>
                  </tr>
                  <tr>
                    <td className="text-left">نشانی واحد صنفی</td>
                    <td className="text-right">{data.address}</td>
                  </tr>
                </tbody>
              </table>
            )}
          </fieldset>
        </div>
      </div>
    ) : (
      <LoadingCircle />
    )
  }
}

function mapStateToProps(state) {
  const { users, authentication } = state
  const { user } = authentication
  return {
    user,
    users
  }
}

const connectedMemberProfile = connect(mapStateToProps)(MemberProfile)
export { connectedMemberProfile as MemberProfile }
